// extracted by mini-css-extract-plugin
module.exports = {"container":"e_zmb","icon":"e_Amb"};